import ImageGallery from "../components/image_gallery/image_gallery"
import TermTitle from "../components/term_title"
import TermDescription from "../components/term_description"
import FullscreenTermInfo from "../components/fullscreen_term_info"
import React from "react"
import {createRoot} from "react-dom/client"
import ajax from "../ajax"
import $ from "cash-dom"

function init_image_gallery(gallery) {
  const $gallery = $(gallery)
  const slugs = gallery.dataset.imageSlugs?.split(",")
  return get_gallery_data(slugs).then((images) => {
    createRoot(gallery).render(<ImageGallery images={images} />)
    $gallery.removeClass("spinner")
  })
}

export async function get_gallery_data(slugs) {
  const images = await ajax.get(
    window.gon.gallery_api_images_path,
    {slugs, locale: window.gon.locale}
  )
  return images.map(image => (
    {
      slug: image.slug,
      title: image.name,
      image_title: image.image_title,
      image_url: image.image_url,
      small_image_url: image.small_image_url,
      thumb_url: image.thumb_url,
      fullscreen_url: image.fullscreen_url,
      perspective: image.perspective,
      fullscreen_info:
        <FullscreenTermInfo
          name={image.name}
          alt_name={image.alt_name}
          audio_url={image.audio_url}
          alt_audio_url={image.alt_audio_url}
          can_play={image.can_play}
          synonyms={image.synonyms}
        />,
      caption: {
        title:
          <TermTitle
            name={image.name}
            alt_name={image.alt_name}
            audio_url={image.audio_url}
            alt_audio_url={image.alt_audio_url}
            can_play={image.can_play}
          />,
        description:
          <TermDescription synonyms={image.synonyms} />
      }
    }
  ))
}

export default init_image_gallery
